let model = {};

model.chartSlaryData = {
  labels: [],
  datasets: [
    {
      label: "Tổng lương",
      data: [],
      borderColor: "#FD1F9B",
      backgroundColor: "transparent",
      yAxisID: "y",
      spanGaps: false
    },
    {
      label: "Số người",
      data: [],
      borderColor: "#30D987",
      backgroundColor: "transparent",
      yAxisID: "y1",
    },
  ],
}
model.optionChartWorkDay = {
  tooltip: {
    trigger: 'item',
    textStyle: {
      fontSize: 16,
      fontFamily: 'UTM Avo',
      fontWeight: 400,
    }
  },
  series: [
    {
      type: 'pie',
      radius: ['40%', '80%'],
      center: ['50%', '50%'],
      color: ['#39ABEC', '#F12727', '#D0D5D9'],
      label: {
        show: false
      },
      labelLine: {
        show: false
      },
      data: [
        { value: 0, name: 'Công đủ' },
        { value: 0, name: 'Lỗi ngày công' },
        { value: 0, name: 'Số ngày còn lại' },
      ],
    },
  ],
}
model.optionChartDetailed = {
  tooltip: {
    trigger: 'item',
    textStyle: {
      fontSize: 16,
      fontFamily: 'UTM Avo',
      fontWeight: 400,
    }
  },
  series: [
    {
      type: 'pie',
      radius: ['40%', '80%'],
      center: ['50%', '50%'],
      color: ['#F79E61', '#FF5621', '#1E3CD7', '#D0D5D9'],
      label: {
        show: false
      },
      labelLine: {
        show: false
      },
      data: [
        { value: 0, name: 'Đi muộn, về sớm' },
        { value: 0, name: 'Nghỉ phép' },
        { value: 0, name: 'Đúng giờ' },
        { value: 0, name: 'Khác' },
      ],
    },
  ],
}

model.optionChartEventMonth = {
  tooltip: {
    trigger: 'item',
    textStyle: {
      fontSize: 16,
      fontFamily: 'UTM Avo',
      fontWeight: 400,
    }
  },
  grid: {
    top: '3%',
    left: '3%',
    right: '3%',
    bottom: '2%',
    containLabel: true
  },
  xAxis: {
    type: 'category',
    data: ['Đúng giờ', 'Đi muộn', 'Công tác', 'Nghỉ phép', 'Online'],
    axisLabel: {
      interval: 0, 
      rotate: 30,
      fontSize: 12,
      fontFamily: 'UTM Avo',
      fontWeight: 'bold',
    }
  },
  yAxis: {
    type: 'value'
  },
  series: [
    {
      data: [
        {
          value: 0,
          itemStyle: {
            color: '#29ff98'
          }
        },
        {
          value: 0,
          itemStyle: {
            color: '#F79D61'
          }
        },
        {
          value: 0,
          itemStyle: {
            color: '#00D1FF'
          }
        },
        {
          value: 0,
          itemStyle: {
            color: '#FF5A5A'
          }
        },
        {
          value: 0,
          itemStyle: {
            color: '#6600FF'
          }
        },
      ],
      type: 'bar'
    }
  ]
}
export default model;
